import { useMemo } from 'react'

import type { CardDetailsListItem } from 'Components/CardDetailsList/CardDetailsList.types'
import { PresentationCard } from 'Components/PresentationCard/PresentationCard'

import type { DeviceTypeEnum } from 'Types/deviceTypes'

import type { RentalPresentationCardProps } from './RentalPresentationCard.types'

export const RentalPresentationCard = (props: RentalPresentationCardProps) => {
  const { title, stocklistItem, deviceDefinition } = props

  const generateListItems = useMemo(
    (): CardDetailsListItem[] => [
      {
        label: 'RentalDetails_imei',
        value: stocklistItem?.imei,
      },
      {
        label: 'RentalDetails_imei2',
        value: stocklistItem?.imei2,
      },
      {
        label: 'RentalDetails_serial',
        value: stocklistItem?.serialNumber,
      },
      {
        label: 'RentalDetails_eid',
        value: stocklistItem?.eid,
      },
    ],
    [
      stocklistItem?.eid,
      stocklistItem?.imei,
      stocklistItem?.imei2,
      stocklistItem?.serialNumber,
    ],
  )

  return (
    <PresentationCard
      header={deviceDefinition?.name ?? ''}
      imagePlaceholderType={deviceDefinition?.productType as DeviceTypeEnum}
      imageSource={deviceDefinition?.imageURL}
      listItems={generateListItems}
      title={title}
    />
  )
}
